import { render } from "./ExternalAuth.vue?vue&type=template&id=5fe11c25&scoped=true"
import script from "./ExternalAuth.vue?vue&type=script&lang=js"
export * from "./ExternalAuth.vue?vue&type=script&lang=js"

import "./ExternalAuth.vue?vue&type=style&index=0&id=5fe11c25&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe11c25"]])

export default __exports__